<script lang="ts" context="module">
  export interface TableData {
    title?: string;
    desc?: string;
    firstColumnColor?: string;
    heads?: string[];
    rows?: Array<any>[];
  }
</script>

<script lang="ts">
  import { onMount } from "svelte";
  import { randomId } from "../scripts/utils";
  import { addLog } from "../stores/LoggerStore";
  const thisViewId = randomId();
  export let tableData: TableData = {};
  let tableContentElem: HTMLElement;

  const setFirstColumnColor = () => {
    if (tableContentElem && tableData.firstColumnColor) {
      const rows = tableContentElem.children;
      for (let k = 0; k < rows.length; ++k) {
        const cols = rows[k].children;
        if (cols.length) {
          (cols[0] as HTMLElement).style.color = tableData.firstColumnColor;
        }
      }
    }
  };
  onMount(() => {
    addLog(`Table id : ${thisViewId}`);
    setFirstColumnColor();
  });
</script>

<div class="container">
  {#if tableData.title}
    <div class="table-title">{tableData.title}</div>
  {/if}
  {#if tableData.desc}
    <div class="table-desc">{tableData.desc}</div>
  {/if}
  {#if tableData.rows}
    <table class="table-content" bind:this={tableContentElem}>
      {#if tableData.heads}
        <thead>
          {#each tableData.heads as head, j (j)}
            <th scope="col">{head}</th>
          {/each}
        </thead>
      {/if}
      {#each tableData.rows as row, i (i)}
        <tr class="table-row {thisViewId}">
          {#each row as col, j (j)}
            <td class={`table-col`}>{col}</td>
          {/each}
        </tr>
      {/each}
    </table>
  {/if}
</div>

<style>
  .container {
    width: 100%;
  }
  .table-title {
    font-weight: 600;
    font-size: 1.4rem;
    padding: 10px 0px 7px 15px;
  }
  .table-desc {
    font-weight: 400;
    padding: 0px 0px 10px 15px;
  }
  .table-col {
    font-weight: 300;
    /* font-size: 0.9rem; */
    padding: 3px 20px;
  }
  .table-col:first-child {
    font-weight: 300;
    font-size: 1.1rem;
    border-right: 1px solid #dbdbdb;
  }
</style>
